import { type IFeatureFlag } from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  asyncStateInitial,
  finishLoading,
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
  startLoading,
} from '../async-state';
import { type IFeatureFlagsState } from './types';

export const preloadedState: IFeatureFlagsState = {
  ...asyncStateInitial,
  featureFlags: undefined,
};

const featureFlagsSlice = createSlice({
  name: 'FeatureFlags',
  initialState: preloadedState,
  reducers: {
    featureFlagsLoadAll(state) {
      startLoading(state);
      state.featureFlags = undefined;
      state.updatedAt = undefined;
    },
    featureFlagsLoadAllResponse: {
      reducer(state, action: { payload: { featureFlags: IFeatureFlag[] } }) {
        state.featureFlags = action.payload.featureFlags;
        finishLoading(state);
      },
      prepare(featureFlags: IFeatureFlag[]) {
        return { payload: { featureFlags } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('FeatureFlags'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const { featureFlagsLoadAll, featureFlagsLoadAllResponse } =
  featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
